import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-line text-2xl"></i>
              </div>
              <span className="font-heading text-xl">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4">游戏分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                {siteInfo.about.contact.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </div>
                微信：{siteInfo.about.contact.wechat}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/20 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {new Date().getFullYear()} {siteInfo.name} - {siteInfo.tagline}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
              aria-label="QQ"
            >
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}